import Vue from 'vue';
import Router from 'vue-router';

import util from './common/utility';

import Login from './views/Login.vue';
import PrayerForm from './views/PrayerForm.vue';
import weeklyMeeting from './views/WeeklyMeeting.vue';
import coreTeamMeeting from './views/CoreTeamMeeting.vue';
import ministryMeeting from './views/MinistryMeeting.vue';
import otherActivities from './views/OtherActivites.vue';
import previewMeetingData from './views/PreviewMeeetingData.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '',
            name: 'login',
            component: Login
        },
        {
            path: '/monthly-report',
            name: 'prayerform',
            redirect: util.loginSuccessRoute,
            component: PrayerForm,
            children: [
                {
                    path: 'weekly-meetings',
                    component: weeklyMeeting
                },
                {
                    path: 'core-team-meetings',
                    component: coreTeamMeeting
                },
                {
                    path: 'discipleship-meetings',
                    component: ministryMeeting,
                    props: {
                        type: 'discipleshipCellMeeting',
                        title: 'Discipleship / Cell Meetings'
                    }
                },
                {
                    path: 'other-ministry-meetings',
                    component: ministryMeeting,
                    props: {
                        type: 'otherMinistryMeeting',
                        title: 'Other Ministry meetings viz. Intercession, Visitation, etc.'
                    }
                },
                {
                    path: 'extra-activities',
                    component: otherActivities
                },
                {
                    path: 'preview-meeting-data',
                    component: previewMeetingData
                }
            ]
        }
    ],
});

router.beforeEach( (to, from, next) => {
    /* if ( to.fullPath !== '/' ) {
        if (to.fullPath === '/log-out') {
            delete localStorage.user;

            next('/');
        } else if ( util.isLoggedIn() ) {
            next();
        } else {
            next('/');
        }
    } else {
        next(util.loginSuccessRoute);
    } */

    if ( util.isLoggedIn() ) {
        if ( to.fullPath === '/' ) {
            next(util.loginSuccessRoute);
        } else if (to.fullPath === '/log-out') {
            if (confirm('Are you sure you want to log out?')) {
                util.logOut();

                next('/');
            }
        } else {
            next();
        }
    } else {
        // if user is not logged in

        // if user tries to access any other
        if ( to.fullPath !== '/' ) {
            next('/');
        } else {
            next();
        }
    }
});

export default router;
